@if (!isMainChatPage || !isMobileView) {
<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo Section -->
    <div class="navbar-logo">
      @if (!isHomePage && !isCreateProfilePage && !isFinancePage && !isWhatsAppBroadcastPage && !hideBackButton) {
      <a (click)="goBack()" class="header-back-btn" title="Back">
        <span class="material-symbols-outlined">arrow_back</span>
      </a>
      }
      <a routerLink="/home" class="logo-link">
        <img src="../../../assets/login/header-logo.png" class="logo-image" alt="Logo" />
      </a>
      <!-- A newer Link is out (30 Oct 2026): one tap loads it -->
      <app-update-button></app-update-button>
      @if (isBetaRoute) { <a class="beta-pill" routerLink="/whats-new" title="This module is still being built. Use it, and tell Manish what is off.">Beta</a> }
    </div>

    <!-- Navigation Links -->
    <!-- <div class="navbar-nav" id="navbarMenu">
        <ul class="nav-list">
          @if (hasModule('CREATE-PROFILE')) {
            <li class="nav-item">
              <a routerLink="/access" class="nav-link" routerLinkActive="active-link">Users</a>
            </li>
          }
          @if (hasModule('CREATE-PROFILE')) {
            <li class="nav-item">
              <a routerLink="/feedback" class="nav-link" routerLinkActive="active-link">Feedbacks</a>
            </li>
          }
        </ul>
      </div> -->

    <!-- Right Actions -->
    <div class="navbar-actions">
      <!-- Tasks (14 Oct 2026) -->
      <div class="action-icon tasks-icon" [class.active]="isTasksPage" (click)="!isTasksPage && router.navigate(['/tasks'])" title="Tasks">
        <span class="material-symbols-outlined">checklist</span>
        @if (taskBadge(); as tb) {
          @if (tb.today > 0) {
            <span class="badge" [class.badge-soft]="tb.overdue === 0">{{ tb.today > 99 ? '99+' : tb.today }}</span>
          }
        }
      </div>
      <div class="action-icon new-task-icon" (click)="newTask()" title="New task">
        <span class="material-symbols-outlined">add_task</span>
      </div>

      <!-- Chat Icon -->
      <div class="action-icon chat-icon" [class.active]="isMainChatPage"
        (click)="!isMainChatPage && router.navigate(['/main-chat'])">
        <span class="material-symbols-outlined">chat_bubble</span>
        @if (unreadCount$ | async; as totalUnreadCount) {
        <span class="badge" [ngClass]="{'d-none': totalUnreadCount === 0}">
          {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
        </span>
        }
      </div>

      <!-- Notifications -->
      <div class="action-icon notification-icon-wrapper" (click)="toggleNotifications()">
        <span class="material-symbols-outlined" [class.active]="showNotificationPanel">notifications</span>
        @if (notificationCount > 0) {
        <span class="badge">
          {{ notificationCount > 99 ? '99+' : notificationCount }}
        </span>
        }
      </div>

      <!-- Mute (30 Oct 2026): pause every notification for a while, on every device -->
      @if (mute.supported()) {
      <div class="mute-wrap" (click)="$event.stopPropagation()">
        <div class="action-icon mute-icon" [class.muted]="mute.muted()" role="button" tabindex="0"
          aria-haspopup="menu" [attr.aria-expanded]="muteMenuOpen"
          [attr.aria-label]="mute.muted() ? 'Notifications muted until ' + muteEndText(mute.mutedUntil()) : 'Mute notifications'"
          [title]="mute.muted() ? 'Notifications muted until ' + muteEndText(mute.mutedUntil()) + ' — click to change' : 'Mute notifications'"
          (click)="toggleMuteMenu()" (keydown.enter)="toggleMuteMenu()" (keydown.space)="$event.preventDefault(); toggleMuteMenu()">
          <span class="material-symbols-outlined">{{ mute.muted() ? 'notifications_off' : 'notifications_paused' }}</span>
          @if (mute.muted()) { <span class="mute-left">{{ muteLeftText() }}</span> }
        </div>
        @if (muteMenuOpen) {
        <div class="mute-menu" role="menu">
          <div class="mute-menu-head">
            <span class="material-symbols-outlined">{{ mute.muted() ? 'notifications_off' : 'notifications_paused' }}</span>
            <div>
              <strong>{{ mute.muted() ? 'Muted until ' + muteEndText(mute.mutedUntil()) : 'Mute notifications' }}</strong>
              <small>No pushes or sounds on any of your devices. Everything still collects under the bell.</small>
            </div>
          </div>
          @for (o of muteOptions; track o.minutes) {
          <button type="button" role="menuitem" class="mute-option" [disabled]="mute.busy()" (click)="chooseMute(o.minutes)">
            <span>{{ o.label }}</span>
            <span class="mute-option-end">until {{ muteEndText(muteEndFor(o.minutes)) }}</span>
          </button>
          }
          @if (mute.muted()) {
          <button type="button" role="menuitem" class="mute-option mute-off" [disabled]="mute.busy()" (click)="chooseMute(0)">
            <span class="material-symbols-outlined">notifications_active</span>
            <span>Unmute now</span>
          </button>
          }
        </div>
        }
      </div>
      }

      <!-- Theme Toggle -->
      <div class="action-icon theme-toggle-btn" (click)="toggleTheme()" title="Toggle Theme">
        <span class="material-symbols-outlined">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</span>
      </div>

      <!-- Profile Dropdown -->
      <div class="profile-dropdown">
        <img [src]="userRecentProfileImg || defaultProfileImage" (error)="handleProfileImageError($event)"
          class="profile-avatar" data-toggle="dropdown" alt="Profile" />
          @if (!whatsNewSeen) { <span class="avatar-dot" title="Something new in Link"></span> }
        <div class="dropdown-menu">
          <div class="dropdown-header">
            <span class="greeting">Hi, {{ this.userRecentName }}!</span>
            @if (userDepartment || userEmployeeId || userEmail) {
            <div class="user-meta-info">
              @if (userDepartment) {
              <div class="meta-row">
                <span class="meta-label">Department:</span>
                <span class="meta-value">{{ userDepartment }}</span>
              </div>
              }
              @if (userEmployeeId) {
              <div class="meta-row">
                <span class="meta-label">Emp ID:</span>
                <span class="meta-value">{{ userEmployeeId }}</span>
              </div>
              }
              @if (userEmail) {
              <div class="meta-row" [title]="userEmail">
                <span class="meta-label">Email ID:</span>
                <span class="meta-value text-truncate">{{ userEmail }}</span>
              </div>
              }
            </div>
            }
            <span class="app-version">Link v{{ appVersion }}</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item whats-new-item" (click)="openWhatsNew()">
            <span class="material-symbols-outlined">auto_awesome</span>
            <span>What's new</span>
            @if (!whatsNewSeen) { <span class="whats-new-dot"></span> }
          </div>
          <div class="dropdown-item" (click)="openSettings()">
            <span class="material-symbols-outlined">settings</span>
            <span>Settings</span>
          </div>
          @if (canInstallPWA) {
          <div class="dropdown-item" (click)="installPWA()">
            <span class="material-symbols-outlined">download</span>
            <span>Install App</span>
          </div>
          }
          @if (canInstallPWA) {
          <div class="dropdown-divider"></div>
          }
          <button class="dropdown-item logout-btn" data-toggle="modal" data-target="#logoutModal">
            <span class="material-symbols-outlined">logout</span>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>

<div class="header-gradient-line"></div>
}

<!-- Notification Panel -->
@if (showNotificationPanel && loadingNotifications) {
<div class="notification-panel loading">
  <div class="notification-loader">
    <div class="loader"></div>
  </div>
</div>
}

@if (showNotificationPanel && !loadingNotifications && totalnotification === 0) {
<div class="notification-panel empty">
  <div class="notification-panel-header">
    <h3>No Notifications</h3>
    <span class="material-symbols-outlined close-btn" (click)="closeNotification()">close</span>
  </div>
  <div class="empty-notification-content">
    <span class="material-symbols-outlined">notifications_none</span>
    <p>You're all caught up!</p>
  </div>
</div>
}

@if (showNotificationPanel && !loadingNotifications && totalnotification > 0) {
<div class="notification-panel">
  <div class="notification-panel-header">
    <h3>Notifications</h3>
    <div class="header-actions">
      @if (hasUnreadNotifications()) {
        <button class="mark-all-read-btn" (click)="markAllAsRead()">
          <span class="material-symbols-outlined">done_all</span>
          <span>Mark all as read</span>
        </button>
      }
      <span class="material-symbols-outlined close-btn" (click)="closeNotification()">close</span>
    </div>
  </div>
  <div class="notification-list" infiniteScroll #infiniteScroller [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false">
    @for (notification of notificationData; track notification; let i = $index) {
    <div class="notification-item" [class.unseen]="!notification.isClicked && notification.status !== 'seen'"
      (click)="handleNotificationRedirect(notification)">
      <img [src]="notification.senderProfileImg" (error)="handleProfileImageError($event)" alt="User"
        class="notification-avatar" />
      <div class="notification-details">
        <div class="notification-message">
          <span class="sender-name">{{ notification.senderName }}</span>
          <p class="notification-subtype">{{ notification.subType }}</p>
          <p class="notification-text">{{ notification.message }}</p>
        </div>
        <span class="notification-time">{{ formatNotificationDate(notification.createdAt) }}</span>
      </div>
    </div>
    }
    @if (!hasMoreNotifications) {
    <div class="notifications-end">
      <span class="material-symbols-outlined">check_circle</span>
      <p>You're all caught up!</p>
    </div>
    }
  </div>
</div>
}

<!-- Logout Modal -->
<div class="modal" id="logoutModal" tabindex="-1" aria-hidden="true">
  <div class="modal-backdrop"></div>
  <div class="modal-wrapper">
    <div class="modal-card">
      <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
        <span class="material-symbols-outlined">close</span>
      </button>

      <div class="modal-icon-wrapper">
        <div class="modal-icon">
          <span class="material-symbols-outlined">logout</span>
        </div>
      </div>

      <h2 class="modal-heading">Sign Out</h2>
      <p class="modal-text">Are you sure you want to sign out of your account?</p>

      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="onClickLogout()">
          <span class="material-symbols-outlined">logout</span>
          Sign Out
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Settings Modal -->
<app-settings-modal [isOpen]="showSettingsModal" (closed)="closeSettings()"></app-settings-modal>